import { Bar, mixins } from 'vue-chartjs'

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    mounted: function() {
        this.chartOptions = {
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 20,
                    bottom: 0
                }
            },
            legend: {
                display: false
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    stacked: true,
                    barPercentage: 1,
                    categoryPercentage: 0.5,
                    gridLines: {
                    display: false
                    },
                    ticks: {
                    fontSize: 10
                    }
                }],
                yAxes: [{
                    stacked: true,
                    barPercentage: 0.5,
                    categoryPercentage: 0.5,
                    display: false,
                    ticks: {
                    beginAtZero: true,
                    fontSize: 10
                    }
                }]
            },
            animation: {
              duration: 2000,
              onProgress: function(animation) {

              },
              onComplete: function () {
                  // render the value of the chart above the bar
                  var ctx = this.chart.ctx;
                  ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                  //ctx.fillStyle = this.chart.config.options.defaultFontColor;
                  ctx.fillStyle="#8ca0b3";
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'bottom';

                  //selects the dataset to pull data from
                  var dataset = this.data.datasets[0];
                  //this.data.datasets.forEach(function (dataset) {
                      for (var i = 0; i < dataset.data.length; i++) {
                          var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                          /*if(dataset.data[i] == 0){
                            ctx.fillText('Occupied', model.x, 15);
                          } else {
                          ctx.fillText(dataset.data[i]+' seats', model.x, 15);
                        }*/
                      ctx.fillText(this.data.datasets[2].data[i], model.x, 15);
                      }
                  //});

              }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                    label: function(tooltipItems, data) {
                        return data.datasets[2].data[tooltipItems.index];
                    }
                }
            },

        }

        this.renderChart(this.chartData, this.chartOptions);
    },
});



// WEBPACK FOOTER //
// ./src/tools/charts/Occupancy.js